import Resources from '@/Resources';
import Config from '@/Config';
import { platform } from '@/Models';

export const pageNavigationTypes = {
    platform: 'platform',
    creator: 'creator',
    system: 'system',
    special: 'special',
};

export function usePagesNavigation() {
    const navigationItems = [
        {
            url: Config.navigation.aboutUsUrl,
            name: Resources.Layout.AboutUsLink,
            isFeatured: false,
            isEnabled: true,
            pageNavigationType: pageNavigationTypes.platform,
            platformType: [platform.gamefound],
        },
        {
            url: Config.navigation.whyGamefoundUrl,
            name: Resources.Layout.WhyGamefoundLink,
            isFeatured: false,
            isEnabled: true,
            pageNavigationType: pageNavigationTypes.platform,
            platformType: [platform.gamefound],
        },
        {
            url: Config.navigation.contactUrl,
            name: Resources.Layout.ContactLink,
            isFeatured: false,
            isEnabled: true,
            pageNavigationType: pageNavigationTypes.platform,
            platformType: [platform.gamefound, platform.ideafound],
        },
        {
            url: Config.navigation.crowdfundingGuideUrl,
            name: Resources.Layout.CrowdfundingGuideLink,
            isFeatured: false,
            isEnabled: true,
            pageNavigationType: pageNavigationTypes.platform,
            platformType: [platform.gamefound, platform.ideafound],
        },
        {
            url: Config.externalUrls.careerUrl,
            name: Resources.Layout.CareerLink,
            isFeatured: false,
            isEnabled: true,
            pageNavigationType: pageNavigationTypes.platform,
            platformType: [platform.gamefound],
        },
        {
            url: Config.navigation.feesUrl,
            name: Resources.Layout.FeesLink,
            isFeatured: false,
            isEnabled: true,
            pageNavigationType: pageNavigationTypes.creator,
            platformType: [platform.gamefound, platform.ideafound],
        },
        {
            url: Config.navigation.marketingServicesUrl,
            name: Resources.Layout.MarketingServicesLink,
            isFeatured: false,
            isEnabled: true,
            pageNavigationType: pageNavigationTypes.creator,
            platformType: [platform.gamefound, platform.ideafound],
        },
        {
            url: Config.navigation.performanceMarketingUrl,
            name: Resources.Layout.PerformanceMarketingLink,
            isFeatured: true,
            isEnabled: Config.siteFeatures.performanceMarketingEnabled,
            pageNavigationType: pageNavigationTypes.creator,
            platformType: [platform.gamefound],
        },
        {
            url: Config.navigation.becomeACreatorUrl,
            name: Resources.Layout.BecomeACreatorLink,
            isFeatured: true,
            isEnabled: true,
            pageNavigationType: pageNavigationTypes.creator,
            platformType: [platform.gamefound, platform.ideafound],
        },
        {
            url: Config.navigation.blogUrl,
            name: Resources.Layout.BlogLink,
            isFeatured: false,
            isEnabled: true,
            pageNavigationType: pageNavigationTypes.creator,
            platformType: [platform.gamefound, platform.ideafound],
        },
        {
            key: 'PrivacyPolicy',
            url: Config.navigation.privacyPolicyUrl,
            name: Resources.Layout.PrivacyPolicyLink,
            isFeatured: false,
            isEnabled: true,
            pageNavigationType: pageNavigationTypes.system,
            platformType: [platform.gamefound, platform.ideafound],
        },
        {
            key: 'ToS',
            url: Config.navigation.termsOfServiceIndexUrl,
            name: Resources.Layout.TermsOfServiceLink,
            isFeatured: false,
            isEnabled: true,
            pageNavigationType: pageNavigationTypes.system,
            platformType: [platform.gamefound, platform.ideafound],
        },
        {
            key: 'CookieSettings',
            url: Config.navigation.cookieSettingsUrl,
            name: Resources.Layout.CookieSettingsLink,
            isFeatured: false,
            isEnabled: true,
            pageNavigationType: pageNavigationTypes.system,
            platformType: [platform.gamefound, platform.ideafound],
        },
        {
            url: Config.externalUrls.helpUrl,
            name: Resources.Layout.HelpLink,
            isFeatured: false,
            isEnabled: true,
            pageNavigationType: pageNavigationTypes.creator,
            platformType: [platform.gamefound, platform.ideafound],
        },
        {
            key: 'WeDoNotSellYourData',
            url: Config.navigation.privacyPolicyUrl,
            name: Resources.Layout.WeDoNotSellYourDataLink,
            isFeatured: false,
            isEnabled: true,
            pageNavigationType: pageNavigationTypes.special,
            platformType: [platform.ideafound],
        },
    ];

    return {
        navigationItems: navigationItems.filter(el => el.isEnabled && el.platformType.includes(Config.platform)),
        navigationItemTypes: pageNavigationTypes,
        platformTypes: platform,
    };
}